import { useEffect, useState } from 'react';
import { createForm, FormType } from 'shared-ui/lib/customs/form/FormGenerator';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import { useFindVehicleQuery } from '../generated/graphql';
import { faultInputs } from '../inputs/fault.input';

export type FaultFormBody = {
  description: string;
  photo: string;
  vehicleId: string;
};

export const useFaultForm = (): FormType | null => {
  const [form, setForm] = useState<FormType | null>(null);
  const { data } = useFindVehicleQuery();

  useEffect(() => {
    const fieldId = faultInputs.vehicleId;
    const f: FormInput[] = [faultInputs.description, faultInputs.photo];
    if (data?.vehicles) {
      fieldId.props.options = data?.vehicles.list.map((v) => {
        const displayName = v.name || v.registerNumber || v.VIN || 'Ajoneuvo';
        const brandModel = [v.brand, v.model].filter(Boolean).join(' ');
        const regVinRaw = [v.registerNumber, v.VIN].filter((x): x is string => Boolean(x))
        const regVin = Array.from(new Set(regVinRaw))
          .filter((x) => x !== displayName)
          .join(', ')

        let label = displayName;

        if (brandModel && regVin) {
          label = `${displayName}, ${brandModel} (${regVin})`;
        } else if (brandModel) {
          label = `${displayName}, ${brandModel}`;
        } else if (regVin) {
          label = `${displayName} (${regVin})`;
        }

        return {
          value: v.id,
          label,
        };
      });
    }
    f.push(fieldId);
    setForm(createForm(f));
  }, [data]);

  return form;
};
